export function baseUrl() {
    const env = process.env.NODE_ENV || 'development'
    // let baseURL =  'https://api-maisonie-gestion.flysoft.cm';
    let baseURL = 'https://api-maisonie-gestion.flysoft.cm';
    if (env === 'production') {
        baseURL = process.env.API_URL || 'https://api-maisonie-gestion.flysoft.cm' //'https://api-maisonie-gestion.flysoft.cm' // 'https://fse-le-maisonier.herokuapp.com/api';
        // baseURL = process.env.API_URL || 'http://localhost:4002' // 'https://fse-le-maisonier.herokuapp.com/api';
    }
    else if (env === 'test') { 

    }
    
    return baseURL;
}

export function apiUrl(url) {
    return `${baseUrl()}/api${url || ''}`;
}